// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderSubscriberPatient,
    ProviderSubscriberPatientSortType,
    SupportCreateSubscriberPatientPayload,
    SupportReplaceSubscriberPatientPayload,
    SupportSubscriberPatient,
    SupportSubscriberPatientSortType,
    SupportUpdateSubscriberPatientPayload,
    SupportCreateSubscriberPatientPayloadToJSON,
    SupportReplaceSubscriberPatientPayloadToJSON,
    SupportUpdateSubscriberPatientPayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderSubscriberPatientFromJSON,
    SupportSubscriberPatientFromJSON,
} from '../models';

export interface CreateSupportSubscriberPatientRequest {
    supportCreateSubscriberPatientPayload: SupportCreateSubscriberPatientPayload;
}

export interface DisableSupportSubscriberPatientRequest {
    id: string;
}

export interface GetProviderSubscriberPatientRequest {
    id: string;
}

export interface GetSupportSubscriberPatientRequest {
    id: string;
}

export interface ListProviderSubscriberPatientsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderSubscriberPatientsOrderEnum>;
    filterCreated?: Array<string>;
    filterRelationship?: Array<string>;
    filterPatientId?: Array<string>;
    filterSubscriberId?: Array<string>;
    filterFirstLast?: Array<string>;
    sort?: Array<ProviderSubscriberPatientSortType>;
}

export interface ListSupportSubscriberPatientsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportSubscriberPatientsOrderEnum>;
    filterStarred?: string;
    filterCreated?: Array<string>;
    filterActive?: string;
    filterRelationship?: Array<string>;
    filterPatientId?: Array<string>;
    filterSubscriberId?: Array<string>;
    filterFirstLast?: Array<string>;
    sort?: Array<SupportSubscriberPatientSortType>;
}

export interface ReplaceSupportSubscriberPatientRequest {
    supportReplaceSubscriberPatientPayload: SupportReplaceSubscriberPatientPayload;
}

export interface UpdateSupportSubscriberPatientRequest {
    id: string;
    supportUpdateSubscriberPatientPayload: SupportUpdateSubscriberPatientPayload;
}

/**
 * no description
 */
export class SubscriberPatientApi extends runtime.BaseAPI {

    /**
     * Create a subscriber patient
     * Create a subscriber patient
     */
    async createSupportSubscriberPatientRaw(requestParameters: CreateSupportSubscriberPatientRequest): Promise<runtime.ApiResponse<SupportSubscriberPatient>> {
        if (requestParameters['supportCreateSubscriberPatientPayload'] === null || requestParameters['supportCreateSubscriberPatientPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateSubscriberPatientPayload','Required parameter requestParameters.supportCreateSubscriberPatientPayload was null or undefined when calling createSupportSubscriberPatient.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:subscriberpatient", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/subscriberpatient`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateSubscriberPatientPayloadToJSON(requestParameters['supportCreateSubscriberPatientPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportSubscriberPatientFromJSON(jsonValue));
    }

    /**
     * Create a subscriber patient
     * Create a subscriber patient
     */
    async createSupportSubscriberPatient(requestParameters: CreateSupportSubscriberPatientRequest): Promise<SupportSubscriberPatient> {
        const response = await this.createSupportSubscriberPatientRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a subscriber patient
     * Disable a subscriber patient
     */
    async disableSupportSubscriberPatientRaw(requestParameters: DisableSupportSubscriberPatientRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportSubscriberPatient.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:subscriberpatient", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/subscriberpatient/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a subscriber patient
     * Disable a subscriber patient
     */
    async disableSupportSubscriberPatient(requestParameters: DisableSupportSubscriberPatientRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportSubscriberPatientRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a subscriber patient
     * Get a subscriber patient
     */
    async getProviderSubscriberPatientRaw(requestParameters: GetProviderSubscriberPatientRequest): Promise<runtime.ApiResponse<ProviderSubscriberPatient>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderSubscriberPatient.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:subscriberpatient"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/subscriberpatient/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderSubscriberPatientFromJSON(jsonValue));
    }

    /**
     * Gets a subscriber patient
     * Get a subscriber patient
     */
    async getProviderSubscriberPatient(requestParameters: GetProviderSubscriberPatientRequest): Promise<ProviderSubscriberPatient> {
        const response = await this.getProviderSubscriberPatientRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a subscriber patient
     * Get a subscriber patient
     */
    async getSupportSubscriberPatientRaw(requestParameters: GetSupportSubscriberPatientRequest): Promise<runtime.ApiResponse<SupportSubscriberPatient>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportSubscriberPatient.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:subscriberpatient", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/subscriberpatient/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportSubscriberPatientFromJSON(jsonValue));
    }

    /**
     * Gets a subscriber patient
     * Get a subscriber patient
     */
    async getSupportSubscriberPatient(requestParameters: GetSupportSubscriberPatientRequest): Promise<SupportSubscriberPatient> {
        const response = await this.getSupportSubscriberPatientRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of subscriber patients
     * Get a list of subscriber patients
     */
    async listProviderSubscriberPatientsRaw(requestParameters: ListProviderSubscriberPatientsRequest): Promise<runtime.ApiResponse<Array<ProviderSubscriberPatient>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterRelationship) {
            queryParameters['filterRelationship'] = requestParameters.filterRelationship;
        }

        if (requestParameters.filterPatientId) {
            queryParameters['filterPatientId'] = requestParameters.filterPatientId;
        }

        if (requestParameters.filterSubscriberId) {
            queryParameters['filterSubscriberId'] = requestParameters.filterSubscriberId;
        }

        if (requestParameters.filterFirstLast) {
            queryParameters['filterFirstLast'] = requestParameters.filterFirstLast;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:subscriber"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/subscriberpatient`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderSubscriberPatientFromJSON));
    }

    /**
     * Gets a list of subscriber patients
     * Get a list of subscriber patients
     */
    async listProviderSubscriberPatients(requestParameters: ListProviderSubscriberPatientsRequest): Promise<Array<ProviderSubscriberPatient>> {
        const response = await this.listProviderSubscriberPatientsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of subscriber patients
     * Get a list of subscriber patients
     */
    async listSupportSubscriberPatientsRaw(requestParameters: ListSupportSubscriberPatientsRequest): Promise<runtime.ApiResponse<Array<SupportSubscriberPatient>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterRelationship) {
            queryParameters['filterRelationship'] = requestParameters.filterRelationship;
        }

        if (requestParameters.filterPatientId) {
            queryParameters['filterPatientId'] = requestParameters.filterPatientId;
        }

        if (requestParameters.filterSubscriberId) {
            queryParameters['filterSubscriberId'] = requestParameters.filterSubscriberId;
        }

        if (requestParameters.filterFirstLast) {
            queryParameters['filterFirstLast'] = requestParameters.filterFirstLast;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:subscriberpatient", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/subscriberpatient`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportSubscriberPatientFromJSON));
    }

    /**
     * Gets a list of subscriber patients
     * Get a list of subscriber patients
     */
    async listSupportSubscriberPatients(requestParameters: ListSupportSubscriberPatientsRequest): Promise<Array<SupportSubscriberPatient>> {
        const response = await this.listSupportSubscriberPatientsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Replace a subscriber patient
     * Replace a subscriber patient
     */
    async replaceSupportSubscriberPatientRaw(requestParameters: ReplaceSupportSubscriberPatientRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['supportReplaceSubscriberPatientPayload'] === null || requestParameters['supportReplaceSubscriberPatientPayload'] === undefined) {
            throw new runtime.RequiredError('supportReplaceSubscriberPatientPayload','Required parameter requestParameters.supportReplaceSubscriberPatientPayload was null or undefined when calling replaceSupportSubscriberPatient.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:subscriberpatient", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/subscriberpatient/replace`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportReplaceSubscriberPatientPayloadToJSON(requestParameters['supportReplaceSubscriberPatientPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Replace a subscriber patient
     * Replace a subscriber patient
     */
    async replaceSupportSubscriberPatient(requestParameters: ReplaceSupportSubscriberPatientRequest): Promise<ObjectNoResponse> {
        const response = await this.replaceSupportSubscriberPatientRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a subscriber patient
     * Update a subscriber patient
     */
    async updateSupportSubscriberPatientRaw(requestParameters: UpdateSupportSubscriberPatientRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportSubscriberPatient.');
        }

        if (requestParameters['supportUpdateSubscriberPatientPayload'] === null || requestParameters['supportUpdateSubscriberPatientPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateSubscriberPatientPayload','Required parameter requestParameters.supportUpdateSubscriberPatientPayload was null or undefined when calling updateSupportSubscriberPatient.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:subscriberpatient", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/subscriberpatient/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateSubscriberPatientPayloadToJSON(requestParameters['supportUpdateSubscriberPatientPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a subscriber patient
     * Update a subscriber patient
     */
    async updateSupportSubscriberPatient(requestParameters: UpdateSupportSubscriberPatientRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportSubscriberPatientRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderSubscriberPatientsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportSubscriberPatientsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
